// Catalyst's dark-navy theme tokens (from soccer-frontend/src/app/globals.css).
// One shared place so the canvas chrome and every widget read the same palette.
// PlayerBioWidget still carries its own copy (Slice C) — left as-is to avoid
// churn; new canvas components use these.
export const theme = {
  page: "#0f172a",
  tile: "#08131e",
  tileHeader: "#0e1e2d",
  surface: "#213658",
  input: "#213658", // form control background (matches Catalyst's inputs)
  field: "#162032",
  border: "#334155",
  borderInput: "#475569",
  ink: "#f1f5f9",
  inkMuted: "#94a3b8",
  inkFaint: "#64748b",
  accent: "#93c5fd",
  accentSurface: "#1e3a5f",
  danger: "#f87171",
} as const;
